import React from 'react'
import FilterBar from '@modules/admin/shared/FiltersBar'
import InputField from '@modules/formFields/InputField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import styled, { css } from 'styled-components'
const SEARCH_FILTERS = 'searchFilter'
const APPLY_FILTERS = 'applyFilters'

export const FilterBarRelations = ({ filters, setFilters, doFetchList, t }) => {
  const doSearch = (search, kind) => {
    if (kind === SEARCH_FILTERS) {
      setFilters((prevState) => ({ ...prevState, search: search }))
      // callback after this in useEffect[filters.search] -Relations.Index-
      return
    }
    if (kind === APPLY_FILTERS) doFetchList()
  }
  const manageChange = (key, value) => {
    setFilters((prevState) => ({ ...prevState, [key]: value }))
  }

  return (
    <FilterWrapper>
      <FilterBar onChange={doSearch} value={filters.search}>
        <InputField
          placeholder={t('Nombre')}
          input={{
            value: filters.nameFilter,
            onChange: (e) => manageChange('nameFilter', e.target.value),
          }}
        />
        <SelectCompanyField
          placeholder={t('Compañías')}
          multi
          input={{
            value: filters.companyFilter,
            onChange: (companies) => manageChange('companyFilter', companies),
          }}
        />
        <InputField
          placeholder={t('Token')}
          input={{
            value: filters.tokenFilter,
            onChange: (e) => manageChange('tokenFilter', e.target.value),
          }}
        />
        <InputField
          placeholder={t('Email')}
          input={{
            value: filters.emailFilter,
            onChange: (e) => manageChange('emailFilter', e.target.value),
          }}
        />
        <InputField
          placeholder={t('Teléfono')}
          input={{
            value: filters.phoneFilter,
            onChange: (e) => manageChange('phoneFilter', e.target.value),
          }}
        />
        <InputField
          placeholder={t('DNI')}
          input={{
            value: filters.nifFilter,
            onChange: (e) => manageChange('nifFilter', e.target.value),
          }}
        />
      </FilterBar>
    </FilterWrapper>
  )
}

const FilterWrapper = styled.div`
  border-bottom: 1px solid lightgray;
  .md-select-basic {
    width: 200px;
  }
  .container-apply-filters {
    justify-content: unset;
    margin-left: 0;
  }
`
export const Banner = styled.div`
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
  margin: 10px;
  ${(props) =>
    props.danger &&
    css`
      color: #721c24;
      background-color: #f8d7da;
      border-color: #f5c6cb;
    `}
`
